import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email });
      toast.success(`Welcome to Lumière. Use code ${data.discount_code} for 10% off your first order.`);
      setEmail('');
    } catch (err) {
      toast.error('Could not subscribe. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-lum-bg2 border-t border-lum-border mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-serif-display text-4xl md:text-5xl leading-[1.05]">Glow letters,<br/>delivered.</h3>
          <p className="mt-4 text-lum-text2 max-w-md">Join 12,000+ readers. Get rituals, skin tips and <span className="text-lum-text">10% off</span> your first order.</p>
          <form onSubmit={subscribe} className="mt-6 flex items-end gap-4 max-w-md">
            <input
              data-testid="footer-newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="input-line"
            />
            <button data-testid="footer-newsletter-submit" disabled={loading} className="btn-primary whitespace-nowrap">
              {loading ? '...' : 'Subscribe'}
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-4">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:underline">All Masks</Link></li>
            <li><Link to="/product/collagen-smoothing-mask" className="hover:underline">Collagen</Link></li>
            <li><Link to="/product/hyaluronic-hydration-mask" className="hover:underline">Hyaluronic</Link></li>
            <li><Link to="/product/vitamin-c-glow-mask" className="hover:underline">Vitamin C</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-4">Discover</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/quiz" className="hover:underline">Skin Quiz</Link></li>
            <li><Link to="/about" className="hover:underline">About</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-4">Promise</p>
          <ul className="space-y-2 text-sm text-lum-text2">
            <li>— Free gift, every order</li>
            <li>— Free shipping over $24</li>
            <li>— Dermatologically tested</li>
            <li>— Cruelty-free & vegan</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-lum-border py-6 px-6 md:px-12 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2">
        <p className="text-xs text-lum-muted">© {new Date().getFullYear()} Lumière Skin. All rights reserved.</p>
        <p className="text-xs text-lum-muted">Made with care for skin that radiates.</p>
      </div>
    </footer>
  );
};
